export default "__VITE_ASSET__CG9C2LiI__"